<template>
  <div>
    <my-header :page_name="$t('navigation.headerTitles.appParams')" show_usermenu></my-header>
    <reference-grid
      :gridData="getAppParamTableArray"
      :columns="columnDefs"
      gridType="param"
      @deleteClicked="deleteClick"
    ></reference-grid>
  </div>
</template>

<script>
import Header from "../../components/reusable/header/Header";
import ReferenceGrid from "../../components/reference/ReferenceGrid";
import i18n from "@/locales";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      columnDefs: []
    };
  },
  methods: {
    deleteClick({currentId, title}) {
      this.$confirm(
        this.$t('appParams.thisActionDeleteParam') + title + ". " + this.$t('appParams.continue') + "?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: this.$t('appParams.cancel'),
          type: "warning"
        }
      )
        .then(() => {
          this.$store.commit("setLoading", true);
          return this.$store.dispatch("deleteAppParam", currentId);
        })
        .then(() => {
          return this.$store.dispatch("getAppParamTable");
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
.catch(() => {
          this.$store.commit("setLoading", false);
        });
    }
  },
  created() {
    this.$store.commit("setLoading", true);
    this.columnDefs = [
      { headerName: i18n.t('tableHeaders.appParam.id'), field: "id" ,
        comparator: (value1, value2) => parseInt(value1) - parseInt(value2),
        cellClass: "center-column",
        width: 80
      },
      { headerName: i18n.t('tableHeaders.appParam.name'), field: "name" }
    ];
    this.$store.dispatch("getAppParamTable").catch(() => {
      this.$store.commit("setLoading", false);
    });
  },
  computed: {
    ...mapGetters(["getAppParamTableArray"])
  },
  components: {
    myHeader: Header,
    ReferenceGrid
  }
};
</script>